import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import Privacy from '../components/privacy/Privacy';
import Footer from '../components/footer/Footer';

const PrivacyPage = () => {

    const { isSideNavOpen } = useContext(SideNavContext);

    return (
        <>
            {isSideNavOpen && <SideNavigation />}

            <Header />

            <main>
                <Privacy />
            </main>

            <Footer />

            <TopButton />
        </>
    );
};

export default PrivacyPage;